export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f04baf6bd78fee65bf2c456b39fd95f91f59bd83a&name=fetchTypeahead!'